import { useState, useEffect } from 'react';
import { getTokenFromLocalStorage } from '../utils/auth';
import apiClient from '../utils/apiClient'; // Đảm bảo apiClient đã được cấu hình đúng cách

const useUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        setError(null);
        const token = getTokenFromLocalStorage();

        if (!token) {
          // Nếu không có token, không thể lấy thông tin người dùng
          setUser(null);
          setLoading(false);
          return;
        }

        // Gọi API để lấy thông tin người dùng
        // Giả định endpoint là '/auth/me' và dữ liệu người dùng nằm trong response.data.user
        const response = await apiClient.get({
          url: '/auth/me',
          headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header Authorization
          },
        });
        setUser(response); // Cập nhật trạng thái người dùng
      } catch (err) {
        console.error('Lỗi khi lấy thông tin người dùng:', err);
        setError(err); // Lưu lỗi nếu có
        setUser(null); // Đặt người dùng về null khi có lỗi
      } finally {
        setLoading(false); // Kết thúc trạng thái loading
      }
    };

    fetchUser();
  }, []); // Mảng phụ thuộc rỗng đảm bảo fetch chỉ chạy một lần khi component mount

  // Trả về thông tin người dùng, trạng thái tải và lỗi,
  // kèm theo hàm setUser để có thể cập nhật lại thông tin người dùng từ bên ngoài nếu cần.
  return { user, loading, error, setUser };
};

export default useUser;
